module.exports = __webpack_public_path__ + "static/media/25.271b0915.png";